import dayjs from "dayjs";
import dayOfYear from "dayjs/plugin/dayOfYear";
import duration from "dayjs/plugin/duration";
import objectSupport from "dayjs/plugin/objectSupport";
import weekOfYear from "dayjs/plugin/weekOfYear";
import weekday from "dayjs/plugin/weekday";
import { dayofmonthCheck, dayofweekCheck, monthCheck, yearCheck, } from "..";
dayjs.extend(objectSupport);
dayjs.extend(weekday);
dayjs.extend(dayOfYear);
dayjs.extend(weekOfYear);
dayjs.extend(duration);
/**
 * An iterator for cron expressions. Will return the next date in the sequence described by the cron string.
 *
 * @author Nico Vitt
 * @param value A QuartzObject
 * @param start The startdate of the cron expression range.
 * @param end The end date of the cron expression range.
 * @param unit The unit that the date is increased by (like 1 day or 1 second)
 */
export function* cronIterator(data, limit //Limit the amount of iterations
) {
    //This is the difference between start and end (e.g. in days)
    let manipulatedDate = data.startdate;
    let index = 0;
    // console.log("start cronIterator", data);
    //Will iterate the amount of differences added to start
    while (index <= limit) {
        //Check if fits quartzobject
        //Currently ignore seconds, minutes, hours
        const fitsquartz = {
            seconds: () => true,
            minutes: () => true,
            hours: () => true,
            dayofmonth: dayofmonthCheck,
            month: monthCheck,
            dayofweek: dayofweekCheck,
            year: yearCheck,
        };
        // console.log(
        //   index,
        //   manipulatedDate.format("YYYY-MM-DD HH:mm:ss"),
        //   Object.values(fitsquartz).map((entry) =>
        //     entry(data.quartzobject, manipulatedDate)
        //   )
        // );
        if (Object.values(fitsquartz).every((entry) => !!entry(data.quartzobject, manipulatedDate))) {
            // //Check if this.weekInterval is modulo value.week()
            // if (this.timeSeries === "weekly") {
            //   // Normalize to number of days in month cycle
            //   const weekinyear = manipulatedDate.week() + 1;
            //   const offset = (weekinyear - this.weekInterval + 52) % 52;
            //   // Check divisibility
            //   if (offset % this.weekInterval === 0) {
            //     yield manipulatedDate;
            //   }
            // }
            yield manipulatedDate;
        }
        manipulatedDate = manipulatedDate.add(1, data.diffunit);
        index++;
    }
    return manipulatedDate;
}
//# sourceMappingURL=CronIterator.js.map